async function fetchJson(url, options = {}) {
  const response = await fetch(url, options);
  const responseBody = await response.json();

  if (!response.ok) {
    throw new Error(`${response.status} ${response.statusText}`);
  }

  return responseBody;
}

export async function requestFellowHealth(baseUrl) {
  return fetchJson(`${baseUrl}/health`);
}

export async function postFellow(baseUrl, payload) {
  return fetchJson(`${baseUrl}/fellow`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload),
  });
}